import round from 'lodash/round';

interface GetCoordinateArgs {
	markerSize: number;
	originalSize: number | string;
	pos: string | number;
	size: number;
}

export const getCoordinate = ({ markerSize, originalSize, pos, size }: GetCoordinateArgs): number => {
	return round((Number(pos) * size) / Number(originalSize) - markerSize / 2, 3);
};

const S3_IMGIX_REGEXP = /https:\/\/motorway\.s3\.eu-west-2\.amazonaws\.com\/photos-assets/;
const IMGIX_BASE_URL = 'https://motorway-photos-assets.imgix.net';

export const s3ToImgix = (s3Url: string): string => {
	if (!s3Url?.includes('/photos-assets/')) return s3Url;
	return s3Url.replace(S3_IMGIX_REGEXP, IMGIX_BASE_URL);
};
